// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"e68d584b","145":"b50bb1ab","218":"139f77ca","236":"0e9c297b","290":"86b35fbf","450":"58b5f2ec","540":"2252b20c","559":"27bb2f4d","565":"a7a860a7","720":"d8484bd2","771":"6c3c54be"}[chunkId] + ".chunk.js";
};